import Popup, { PopupUpgradeHeader } from '../PopupOverlay';
import { useApp } from '../../../contexts/AppContext';
import { isCalmEvent } from '../../../lib/events';
import { getQuote } from '../../../lib/farming/quotes';
import RunningText from '../../../components/RunningText';
import MeerkatHeadAnimated from '../../../components/Icons/MeerkatHeadAnimated';
import { IconCalm } from '../../../components/Icons/IconCalm';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export const ContainerAnimation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 800px;
  margin-top: 40px;
  margin-bottom: 40px;

  @keyframes pulseAnimation {
    0% {
      transform: scale(0.95);
    }

    50% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.95);
    }
  }

  > svg {
    height: auto;
    position: absolute;
    top: 200px;
    left: 100px;
    width: 150px;
    z-index: 100;
    animation: pulseAnimation 2s infinite;

    &:first-of-type {
      width: 300px;
      left: 100px;
      top: 570px;
    }

    &:nth-of-type(3) {
      width: 200px;
      left: 650px;
      top: 450px;
    }
  }
`;

const Calm = () => {
  const { event } = useApp();
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  const quote = getQuote('fuel', currentLanguage);

  if (!isCalmEvent(event)) throw new Error('Should not happen');

  return (
    <Popup hideClose buttonText="Close" onConfirm={async () => {}}>
      <PopupUpgradeHeader>{t('boosts.upgrade')}!</PopupUpgradeHeader>
      <ContainerAnimation>
        <IconCalm />
        <IconCalm />
        <IconCalm />
        <MeerkatHeadAnimated />
      </ContainerAnimation>
      <RunningText text={quote} />
    </Popup>
  );
};

export default Calm;
